/*
  Bilder unter dem Falz wirklich spaet laden.

  Warum es loading="lazy" allein nicht tut (gemessen am 16.10.2026, Handy,
  390 px, 1,6 Mbit/s): Chromium vergroessert die Schwelle fuer traege Bilder,
  je langsamer die Leitung ist. Ein Bild 1700 px unter dem Falz wird dadurch
  sofort geholt. Auf der Startseite lagen so 637 KB auf der Leitung, bevor das
  groesste sichtbare Bild fertig war — bei 1,6 Mbit/s rund 3,2 s. Ohne das
  schwerste dieser Bilder sind es 441 KB und 1,65 s.

  Darum stehen die Adressen in data-Attributen (siehe snippets/sus-bild.liquid)
  und werden hier freigeschaltet: beim Naeherkommen, spaetestens wenn die Seite
  fertig geladen ist. Ohne JavaScript greift das <noscript> im Snippet.
*/
(() => {
  const freischalten = (bild) => {
    if (!bild || bild.dataset.susSpaet === 'fertig') return;
    bild.dataset.susSpaet = 'fertig';

    // Steht das Bild in einem <picture>, muessen die <source> zuerst dran:
    // Sobald das <img> eine Quelle hat, waehlt der Browser aus, was dann da
    // ist — und das waere sonst der JPEG-Rueckfall statt AVIF.
    const kasten = bild.parentElement;
    if (kasten && kasten.tagName === 'PICTURE') {
      kasten.querySelectorAll('source[data-srcset]').forEach((q) => {
        q.setAttribute('srcset', q.dataset.srcset);
        q.removeAttribute('data-srcset');
      });
    }

    if (bild.dataset.srcset) {
      bild.setAttribute('srcset', bild.dataset.srcset);
      delete bild.dataset.srcset;
    }
    if (bild.dataset.src) {
      bild.setAttribute('src', bild.dataset.src);
      delete bild.dataset.src;
    }
  };

  const alle = () => document.querySelectorAll('img[data-sus-spaet]:not([data-sus-spaet="fertig"])');

  const starten = () => {
    const liste = alle();
    if (!liste.length) return;

    if (!('IntersectionObserver' in window)) {
      liste.forEach(freischalten);
      return;
    }

    const wache = new IntersectionObserver((eintraege, selbst) => {
      eintraege.forEach((e) => {
        if (!e.isIntersecting) return;
        freischalten(e.target);
        selbst.unobserve(e.target);
      });
    }, { rootMargin: '600px 0px' });

    liste.forEach((b) => wache.observe(b));

    // Netz: Ist die Seite fertig, darf nichts mehr warten — auch nicht, wenn
    // der Besucher gar nicht scrollt.
    const nachziehen = () => alle().forEach(freischalten);
    if (document.readyState === 'complete') setTimeout(nachziehen, 200);
    else window.addEventListener('load', () => setTimeout(nachziehen, 200), { once: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starten, { once: true });
  } else {
    starten();
  }
})();
